{
  "logInToYourAccount": "Log in to your account",
  "donTAlreadyHaveAn": "Don’t already have an account with Campus Guardian Angel but you need to onboard? You should have received an invite link from Campus Guardian Angel to get going. Any questions, please go ahead and",
  "contactUs": "contact us",
  "enterYourPin": "Enter your Code",
  "pleaseVerifyTheRecaptcha": "Please verify the reCAPTCHA!",
  "youReAllSet": "You're all set!",
  "congratsYouVeSetUp": "Congrats, you’ve set up your district as well as your first campus. You can add buildings and more campuses in our admin panel.",
  "letSGo": "Let’s Go!",
  "createYourAccount": "Create Your Account",
  "verificationComplete": "Verification Complete",
  "greatYourAccountIsVerified": "Great! Your account is verified. Now you’ll need to set up your district. You’ll begin by creating your district, then you can add campuses. Once your structure is ready, you can set up sync with your school directory (e.g. Active Directory) to import users.",
  "phone": "Phone",
  "weLlTextAPin": "We’ll text a PIN code to your cellphone to get you access."
}
